import axios from "axios";
import { API_URL } from "../App";

export const apiRequest = async (
  endpoint,
  method = "GET",
  data = {},
  params = {}
) => {
  const config = {
    method,
    url: `${API_URL}/${endpoint}`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    params: method === "GET" ? { ...params } : {},
    data: method !== "GET" ? { ...data } : null,
  };

  try {
    const response = await axios(config);
    if (response.data[0]?.error_msg) {
      throw new Error(response.data[0].error_msg);
    }
    return response.data;
  } catch (error) {
    console.error(`Błąd API: ${error.message}`);
    return null;
  }
};
/* Wywoływanie:
Przykład bez parametrów (GET):
const response = await apiRequest("get-user");

Przykład z parametrem w URL (GET)
GET http://api.example.com/get-user?id=123&cookie=XYZ

Przykład z danymi w body (POST)
const response = await apiRequest("update-user", "POST", { name: "John Doe" });

Przykład dla PUT z parametrami i danymi:
PUT http://api.example.com/update-user?id=123&cookie=XYZ
Body: { "name": "John Doe", "cookie": "XYZ" }
*/
